import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import BasePtpForm from "../base-ptp-form";
import Utils from "src/utils";
import {PerFormaAPIService} from "src/app/services/pfapi.service";

@Component({
    selector: "app-payment",
    templateUrl: "./payment.component.html",
    styleUrls: ["./payment.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PaymentComponent extends BasePtpForm implements OnInit {
    constructor(
        api: PerFormaAPIService,
        private route: ActivatedRoute
    ) {
        super(api);
    }

    ModalOptions = {animation: false, backdropClass: "backdrop"};
    PO: any = {};
    NewRequest: any = {};
    POID;

    // nz-date-picker models (Date); the backend exchanges these as MM/dd/yyyy strings on PO
    PaymentDate: Date | null = null;
    DueDate: Date | null = null;

    Refresh() {
        this.getData();
    }

    getData = () => {
        this.api.getApiPTPGetPayment({poId: this.POID}).subscribe({
            next: (data: any) => {
                // Set scope purchase order.
                this.PO = data;
                this.PO.CreateDate = Utils.FormatDate(new Date(this.PO.CreateDate));

                // hydrate the date pickers from the MM/dd/yyyy strings the api returns
                this.PaymentDate = this.parseDate(this.PO.PaymentDate);
                this.DueDate = this.parseDate(this.PO.DueDate);

                // Set loading as false.
                this.Loading = false;

                // see if we need to scroll
                if (this.DoScroll && this.ScrollTo?.length > 0) {
                    setTimeout(() => {
                        this.ScrollToElement(this.ScrollTo);
                    }, 500);
                }
            },
            error: error => {
                this.Error(error.error);
                this.Loading = false;
            }
        });
    };

    ngOnInit(): void {
        window.addEventListener("message", event => {
            if (event?.data?.action === "SaveForm") {
                this.Update(() => {
                    window.parent.postMessage({...event.data, action: "LoadForm"});
                });
            }
        });

        // get the query params
        const params = new URL(window.location.toString()).searchParams;

        const show = params.get("show") ?? "";

        if (show != "") {
            this.DoScroll = true;
            this.ScrollTo = show;
        }

        this.route.queryParams.subscribe(f => {
            if (f.poid) {
                this.POID = f.poid;
                this.getData();
            }
        });
    }

    // Updates the PO request with the scope model.
    Update = (next?: () => void) => {
        this.Loading = true;
        const payDate = this.formatDate(this.PaymentDate);
        const dueDate = this.formatDate(this.DueDate);
        this.api.postApiPTPUpdatePayment({...this.PO, DueDate: dueDate, PaymentDate: payDate}).subscribe(
            next ??
                (() => {
                    this.getData();
                    this.Success("Updated successfully");
                })
        );
    };

    // MM/dd/yyyy string -> Date (null when empty/invalid)
    private parseDate = (value: string): Date | null => {
        if (!value) {
            return null;
        }
        const [month, day, year] = value.split("/").map(p => parseInt(p, 10));
        if (isNaN(month) || isNaN(day) || isNaN(year)) {
            return null;
        }
        return new Date(year, month - 1, day);
    };

    // Date -> MM/dd/yyyy string (empty when not set), the format the backend payment filter expects
    private formatDate = (date: Date | null): string => {
        if (!(date instanceof Date) || isNaN(date.getTime())) {
            return "";
        }
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${mm}/${dd}/${date.getFullYear()}`;
    };

    OpenFileInline = doc => {
        this.fileDownload.openDocumentFile(doc.DocumentFileID, true);
    };

    OpenFile = doc => {
        this.fileDownload.openDocumentFile(doc.DocumentFileID, false);
    };

    OpenDoc = doc => {
        window.open("/document/documentedit?id=" + doc.DocumentID);
    };

    Success = message => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-expect-error
        window.parent.successAlert(message);
    };

    // Gets the total of all line items.
    GetLinesItemTotal = () => {
        let total = 0;
        if (this.PO && this.PO.LineItems && this.PO.LineItems.length > 0) {
            for (let i = 0; i < this.PO.LineItems.length; i++) {
                const item = this.PO.LineItems[i];
                total += item.Quantity * item.Price;
            }
        }

        return total.toFixed(2);
    };
}
